import axios from "axios";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import config from "../../config";
import tokenService from "../token.service";
import storage from "../../utils/storage";
import apiConfig from "../../api.config";
import { OauthModel } from "../../model/oauth.model";




const instanceHR9 = axios.create({
  baseURL: config.authen.leela.host_url,
  headers: {
    "Content-Type": "application/json",
  },
})

export const instanceRefresh = axios.create({
  baseURL: config.authen.api.host_url,
  headers: {
    "Content-Type": "application/x-www-form-urlencoded",
  },
});

instanceHR9.interceptors.request.use(
  (config) => {
    if (!config.headers['Content-Type']) {
      config.headers['Content-Type'] = 'application/json';
    }
    const token = tokenService.getLocalAccessToken();
    if (token) {
      config.headers["companyuuid"] = localStorage.getItem(storage.company_uuid);
      // config.headers["Authorization"] = 'Bearer ' + token;  // for Spring Boot back-end
      config.headers["scoutout-authorization"] = token; // for Node.js Express back-end
    }
    return config;
  },
  (error) => {
    alert("กรุณา Login ใหม่");
    window.open('/authen')
    return Promise.reject(error);
  }
);

instanceHR9.interceptors.response.use(
  (res) => {
    return res;
  },
  async (err) => {
    const originalConfig = err.config;
    if (originalConfig.url !== apiConfig.authen.token && err.response) {
      // Access Token was expired
      if (err.response.status === 401 && !originalConfig._retry) {
        originalConfig._retry = true;

        try {
          const rs = await instanceRefresh.post(apiConfig.authen.token, {
            grant_type: 'refresh_token',
            refresh_token: tokenService.getLocalRefreshToken(),
          });
          const token = rs.data as OauthModel
          tokenService.updateLocalAccessToken(token.access_token);

          return instanceHR9(originalConfig);
        } catch (_error) {
        
          return Promise.reject(_error);
        }
      }
    }

    return Promise.reject(err);
  }
);

export default instanceHR9;